// import { Button, Menu, MenuItem } from "@mui/material";
import logo from "../../assets/images/codeWeekLogo.png";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
// import { useState } from "react";
import { Link } from "react-router-dom";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Header = () => {
  // const [anchorEl, setAnchorEl] = useState(null);
  // const open = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  return (
    <header>
      <Container fixed>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <div className="mainHeader">
              <Link to={"https://codeweek.eu/"} target="_blank">
                <img src={logo} alt="Logo Code4Week" />
              </Link>
              <Link to={"/"}>Home</Link>
              {/* <div>
                <Button
                  id="demo-positioned-button"
                  aria-controls={open ? "demo-positioned-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  endIcon={<KeyboardArrowDownIcon />}
                >
                  Activities
                </Button>
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                  }}
                >
                  <MenuItem onClick={handleClose}>
                    <Link to={"/"}>Profile</Link>
                  </MenuItem>
                  <MenuItem onClick={handleClose}>My account</MenuItem>
                  <MenuItem onClick={handleClose}>Logout</MenuItem>
                </Menu>
              </div> */}
            </div>
          </Grid>
        </Grid>
      </Container>
    </header>
  );
};

export default Header;
